<template>
	<div class="minotorPage" style="height: 100%;">
		<wc-header headerTitle="全局监控" :BackisShow=BackisShow></wc-header>
		<wc-monitor></wc-monitor>
	</div>
</template>
<script>
	export default{
		name:'Monitor',
		data(){
			return {
				BackisShow:true
			}
		}
	}
</script>
<style>
	.minotorPage{
		background: #F3F3F3;
	}
</style>


// WEBPACK FOOTER //
// src/views/monitor/Monitor.vue